/* A Policy Studio detail route is named by the Content Library (PaAPI)
   policy id. Before it loads, the policy is opened in Studio if this is its
   first visit, and an id Content Library does not have stops at a 404. Once
   per id per tab, so stepping one policy's rows never waits on the registry. */
import { ensureStudioPolicy } from '~/utils/policy-studio/registry'

const opened = new Set<string>()

export default defineNuxtRouteMiddleware(async (to) => {
  const id = String(to.params.id)
  if (opened.has(id)) return
  if (await ensureStudioPolicy(id)) {
    opened.add(id)
    return
  }
  return abortNavigation(
    createError({
      statusCode: 404,
      statusMessage: `${id} is not a Content Library policy`,
    }),
  )
})
